import { useQuery } from "@tanstack/react-query";
import { useRouteMatch } from "react-router-dom";
import { HOSummaryEmployeeRequestService } from "../../../../../services/human-organization/summary-register-request.service";
export const useGetDetailRequests = () => {
  const { id } = useRouteMatch().params as any;

  const response = useQuery({
    queryKey: ["detail-summary-employee-request", id],
    queryFn: () => HOSummaryEmployeeRequestService.getDetailsSummaryEmployeeRequest(id),
    refetchOnMount:"always"
  });

  return response;
};